// extracted by mini-css-extract-plugin
export default {"link":"styles_link__GwKOZ","outlined":"styles_outlined__eL2io","white":"styles_white__c1PRC","pink":"styles_pink__+SGF0"};